import React, { useState, useEffect } from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ResponsiveContext = React.createContext({
  breakpoints: {},
  orientation: {
    portrait: false,
    landscape: false
  },
  device: {
    isMobile: false,
    isDesktop: false,
    isAndroid: false,
    isIos: false,
    isChromium: false,
    isFirefox: false,
    isSafari: false
  },
  os: { isApple: false, isWindows: false }
});
function registerBreakpoint(theme, size) {
  const [state, setState] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const query = window.matchMedia(`(max-width: ${theme.breakpoints[size]})`);
    setState(query.matches);
    const listener = (e) => {
      setState(query.matches);
    };
    query.addListener(listener);
    return () => query.removeListener(listener);
  }, [size, theme]);
  return {
    [size]: state
  };
}
function registerOrientation() {
  if (typeof window === "undefined") {
    return { portrait: false, landscape: false };
  }
  const mql = window.matchMedia("(orientation: portrait)");
  const updateOrientation = (m) => m.matches ? "portrait" : "landscape";
  const [orientation, setOrientation] = useState(updateOrientation(mql.matches));
  useEffect(() => {
    const updateOrientationHandler = (m) => setOrientation(updateOrientation(m));
    mql.addListener(updateOrientationHandler);
    return mql.removeListener(updateOrientationHandler);
  }, [mql]);
  return {
    portrait: orientation === "portrait",
    landscape: orientation === "landscape"
  };
}
function registerDevice() {
  if (typeof window === "undefined") {
    return {
      isMobile: false,
      isDesktop: false,
      isAndroid: false,
      isIos: false,
      isChromium: false,
      isFirefox: false,
      isSafari: false
    };
  }
  const { userAgent } = navigator;
  const isChromium = Boolean(window.navigator.vendor.includes("Google"));
  const isFirefox = Boolean(window.navigator.userAgent.includes("Mozilla") && !window.navigator.vendor.includes("Apple") && !window.navigator.vendor.includes("Google"));
  const isSafari = Boolean(window.navigator.userAgent.includes("Mozilla") && window.navigator.vendor.includes("Apple"));
  const isOpera = Boolean(userAgent.match(/Opera Mini/i));
  const isWindows = Boolean(userAgent.match(/IEMobile/i));
  const isAndroid = Boolean(userAgent.match(/Android/i));
  const isIos = Boolean(userAgent.match(/iPhone|iPad|iPod/i));
  const isMobile = Boolean(isAndroid || isIos || isOpera || isWindows);
  const isDesktop = !isMobile;
  return {
    isMobile,
    isDesktop,
    isAndroid,
    isIos,
    isChromium,
    isFirefox,
    isSafari
  };
}
const orderedBreakpoints = ["xs", "sm", "ms", "md", "ml", "lg", "xl", "xxl", "jb"];
function registerOS() {
  if (typeof window === "undefined") {
    return { isApple: false, isWindows: false };
  }
  const isApple = Boolean(navigator.appVersion.includes("Mac"));
  const isWindows = Boolean(navigator.appVersion.includes("Win"));
  return {
    isApple,
    isWindows
  };
}
const ResponsiveProvider = ({ children, theme }) => {
  const state = {
    breakpoints: orderedBreakpoints.reduce((accumulator, bp) => __spreadValues(__spreadValues({}, accumulator), registerBreakpoint(theme, bp)), {}),
    orientation: registerOrientation(),
    device: registerDevice(),
    os: registerOS()
  };
  return /* @__PURE__ */ React.createElement(ResponsiveContext.Provider, {
    value: state
  }, children);
};
ResponsiveProvider.displayName = "Maestro.ResponsiveProvider";

export { ResponsiveContext, ResponsiveProvider, orderedBreakpoints };
//# sourceMappingURL=responsive.es.js.map
